module.exports = __webpack_public_path__ + "static/media/wheels-5.9e10aabb.png";